import { useModals } from '@frontend/modal';
import { useAccountRepository } from '@frontend/repository';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useKits = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { openModal } = useModals();
    const createKitModalId = 'create-kit-modal';

    return {
        dispatch,
        currentAccount,
        navigate,
        location,
        openModal,
        createKitModalId
    };
};
